import { render, staticRenderFns } from "./ClaimDocuments.vue?vue&type=template&id=ef037c14&scoped=true&"
import script from "./ClaimDocuments.vue?vue&type=script&lang=js&"
export * from "./ClaimDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef037c14",
  null
  
)

export default component.exports